import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  Modal,
} from '@resy/ui-kitchen';
import GdaOnboarding from './GdaOnboarding';

const GdaOnboardingModal = ({
  closeModal, gdaUrl, isGdaUser, isMobile, isOpen,
}) => {
  const [gdaOnboardingIsOpen, setGdaOnboardingIsOpen] = useState(isOpen);

  const getStyles = () => (
    {
      content: {
        border: 'none',
        maxWidth: isMobile ? '768px' : '700px',
        padding: '0',
        inset: isMobile ? '0' : '30px 40px auto',
      },
    }
  );

  const gdaOnboardingCloseModal = () => {
    if (closeModal) {
      closeModal();
    }
    setGdaOnboardingIsOpen(false);
  };

  return (
    <Modal
      isOpen={gdaOnboardingIsOpen}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onRequestClose={gdaOnboardingCloseModal}
      styles={getStyles()}
    >
      <GdaOnboarding
        closeModal={gdaOnboardingCloseModal}
        gdaUrl={gdaUrl}
        isGdaUser={isGdaUser}
        isMobile={isMobile}
      />
    </Modal>
  );
};

GdaOnboardingModal.propTypes = {
  closeModal: PropTypes.func,
  gdaUrl: PropTypes.string,
  isGdaUser: PropTypes.bool,
  isMobile: PropTypes.bool,
  isOpen: PropTypes.bool,
};

GdaOnboardingModal.defaultProps = {
  closeModal: undefined,
  gdaUrl: undefined,
  isGdaUser: false,
  isMobile: false,
  isOpen: true,
};

export default GdaOnboardingModal;
